export default class MixinHelper {

    // s. https://www.typescriptlang.org/docs/handbook/mixins.html
    public static applyMixins(derivedCtor: any, baseCtors: any[]) {
        baseCtors.forEach(baseCtor => {
            Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
                if (name != "constructor")
                    derivedCtor.prototype[name] = baseCtor.prototype[name];
            });
        });
    }

}